module.exports = __webpack_public_path__ + "img/gray-dark-02-mini.a14834e1.png";